import shouldShowForEnvironment from '../shouldShowForEnvironment/index.js';

// eslint-disable-next-line @typescript-eslint/ban-types

function withDeprecationWarning(obj, deprecatedProperties) {
  if (deprecatedProperties === void 0) {
    deprecatedProperties = {};
  }

  var handler = {
    get(target, property) {
      var isDeprecatedProperty = Object.keys(deprecatedProperties).includes(property);

      if (shouldShowForEnvironment() && isDeprecatedProperty) {
        // eslint-disable-next-line no-console
        console.warn("[Deprecation Warning]: ".concat(deprecatedProperties[property]));
      } // eslint-disable-next-line @typescript-eslint/no-unsafe-return


      return target[property];
    }

  };
  return new Proxy(obj, handler);
}

export { withDeprecationWarning as default };
